import dashboardApi from 'services/api/dashboard'

import {
  completeMagicLinkLogin,
  mapPendingLoginStatusToSocketPayload
} from './completeMagicLinkLogin'

const POLL_INTERVAL_MS = 3000
// Matches api-dashboard AdminSessionAuthorizationExpirationInMinutes (login begin window).
const MAX_POLL_DURATION_MS = 30 * 60 * 1000

let activePollSessionId = null
let activePollTimeoutId = null
let activePollInFlight = false
let activePollStartedAt = null

export function stopMagicLinkLoginPolling() {
  activePollSessionId = null
  activePollInFlight = false
  activePollStartedAt = null

  if (activePollTimeoutId != null) {
    clearTimeout(activePollTimeoutId)
    activePollTimeoutId = null
  }
}

export function startMagicLinkLoginPolling(dispatch, sessionId) {
  if (!sessionId) {
    return
  }

  if (activePollSessionId === sessionId && activePollTimeoutId != null) {
    return
  }

  stopMagicLinkLoginPolling()
  activePollSessionId = sessionId
  activePollStartedAt = Date.now()

  const poll = async () => {
    if (activePollSessionId !== sessionId) {
      return
    }

    if (Date.now() - activePollStartedAt >= MAX_POLL_DURATION_MS) {
      stopMagicLinkLoginPolling()
      return
    }

    if (activePollInFlight) {
      activePollTimeoutId = setTimeout(poll, POLL_INTERVAL_MS)
      return
    }

    activePollInFlight = true

    try {
      const result = await dashboardApi.getLoginPendingStatus(sessionId)
      const payload = mapPendingLoginStatusToSocketPayload(result)

      if (payload && completeMagicLinkLogin(dispatch, payload)) {
        stopMagicLinkLoginPolling()
        return
      }
    } catch (error) {
      console.warn('magic link login polling failed', error)
    } finally {
      activePollInFlight = false
    }

    if (activePollSessionId === sessionId) {
      activePollTimeoutId = setTimeout(poll, POLL_INTERVAL_MS)
    }
  }

  activePollTimeoutId = setTimeout(poll, POLL_INTERVAL_MS)
}
